export class GetTableDataQualityWidgetSeriesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "widgetKey",
            "baseName": "widgetKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "series",
            "baseName": "series",
            "type": "MetricTimeseries",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityWidgetSeriesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
